export default __webpack_public_path__ + "static/media/benefit_17@3x.b5691bfc.png";